/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    CANCEL: 'Abbrechen',
    CONFIRM: 'Bestätigen',
    SAVE: 'Speichern'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Soziale netzwerk',
    USERNAME: 'Benutzername'
  },
  LABEL: {
    CREATE_LINK: 'Soziales Netzwerk hinzufügen',
    EDIT_LINK: 'Soziales Netzwerk bearbeiten',
    INACTIVATE_LINK: 'Soziales Netzwerk löschen',
    INACTIVATE_LINK_MODAL_TITLE: 'Soziales Netzwerk löschen',
    LINK: 'Link',
    SOCIAL_NETWORK: 'Soziale netzwerk',
    USERNAME: 'Benutzername'
  },
  SENTENCE: {
    ERROR: 'Fehler',
    INACTIVATE_LINK_TEXT:
      'Möchtest du dieses soziale Netzwerk wirklich löschen?',
    NO_ROWS_LINKS: 'Keine sozialen netzwerk'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Das soziale Netzwerk wurde erfolgreich gelöscht',
    LINKS_DETAILS_SAVED: 'Das soziale Netzwerk wurde erfolgreich gespeichert',
    LINKS_DETAILS_UPDATED:
      'Das soziale Netzwerk wurde erfolgreich aktualisiert',
    SUCCESS: 'Erfolg'
  },
  TOOLTIP: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Soziale netzwerk',
    USERNAME: 'Benutzername'
  }
};
